/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import {
  Trash,
  PencilSimpleLine,
  Eye,
  DotsThreeVertical,
  DownloadSimple,
  Users,
  ChartBar,
  Upload,
  Clock,
  CheckCircle,
  XCircle,
  Globe,
  Building,
  MagnifyingGlass,
  Plus,
  FunnelSimple
} from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Template from "./Template";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

const PaperDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getPageFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get("page"), 10);
    return isNaN(page) || page < 1 ? 1 : page;
  };
  const [currentStep, setCurrentStep] = useState(1);

  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [paperName, setPaperName] = useState("");
  const [ID, setID] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [buttonText, setButtonText] = useState("Add Paper");
  const [userPermissions, setUserPermissions] = useState({});
  const [userPermissions1, setUserPermissions1] = useState({});
  const [selectedModules, setSelectedModules] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [modules, setModules] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [examMode, setExamMode] = useState("");
  const [attempts, setAttempts] = useState(1);
  const [tabSwitchLimit, setTabSwitchLimit] = useState(0);
  const [duration, setDuration] = useState(60);
  const [publishModal, setPublishModal] = useState(false);
  const [publishDate, setPublishDate] = useState("");
  const [publishPaperId, setPublishPaperId] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [students, setStudents] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selections, setSelections] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [confirmEvaluate, setConfirmEvaluate] = useState(false);
  const [evaluateId, setEvaluateId] = useState(null);
  const [evaluating, setEvaluating] = useState(false);
  const [examFilter, setExamFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(getPageFromUrl);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [examInstructions, setExamInstructions] = useState("");
  const [sections, setSections] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const [examTypes, setExamTypes] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");

  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [newTemplateCreated, setNewTemplateCreated] = useState(false);
  const [previousYear, setPreviousYear] = useState(false);

  const TableLoader = ({ rows = 10, columns = 5 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  useEffect(() => {
    auth();
    auth1();
    fetchModules();
    fetchTemplates();
    fetchBranches();
    fetchExamType()
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 10);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function auth1() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 18);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions1(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions1({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchTemplates() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("limit", 1000);

      const templateResponse = await api.post("templates/templateCurl", fd);
      if (templateResponse.data && Array.isArray(templateResponse.data.getTemplateDetails)) {
        setTemplates(templateResponse.data.getTemplateDetails);
      } else {
        setTemplates([]);
      }
    } catch (error) {
      setTemplates([]);
    }
  }

  async function fetchBranches() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getBranchDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const res = await api.post("class/classCurl", fd);
      console.log("branches", res)

      if (res?.data?.getResponse) {
        const branch = res.data.getResponse.find((b) => b.id === 3);

        setBranches(res.data.getResponse);

        if (branch) {
          setSelectedBranch({
            label: branch.branchName,
            value: branch.id,
          });
        }
      } else {
        setBranches([]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranches([]);
    }
  }

  const studentOptions = students
    .filter(s => !selectedStudents.some(sel => sel.value === s.id))
    .map(s => ({
      value: s.id,
      label: `${s.roll} - ${s.first_name} ${s.last_name}`,
    }));

  async function fetchSections(branchId, classNames = []) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSectionDetails");
      fd.append("branch", branchId);

      classNames.forEach(cls => {
        fd.append("class[]", cls);
      });

      const res = await api.post("class/classCurl", fd);
      console.log("sections", res)

      if (res?.data?.getResponse) {
        setSections(prev => {
          const existingIds = prev.map(s => s.id);
          const newOnes = res.data.getResponse.filter(
            s => !existingIds.includes(s.id)
          );
          return [...prev, ...newOnes];
        });
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  }

  async function fetchStudents(branchId, className, append = false) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getStudentDetails");
      fd.append("branch", 1);
      fd.append("class[]", className);

      selectedSections.forEach(sec => {
        fd.append("sections[]", sec.value);
      });

      const res = await api.post("class/classCurl", fd);
      console.log("students", res)
      if (res?.data?.data && Array.isArray(res.data.data)) {
        setStudents(prev =>
          append
            ? [...prev, ...res.data.data.filter(s => !prev.some(p => p.id === s.id))]
            : res.data.data
        );
      } else {
        setStudents([]);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudents([]);
    }
  }

  useEffect(() => {
    if (students.length > 0) {
      setSelectedStudents((prevSelected) => {
        const prevIds = new Set(prevSelected.map(s => s.value));

        const autoSelected = students
          .filter(s => !prevIds.has(s.id))
          .map(s => ({
            value: s.id,
            label: `${s.roll} - ${s.first_name} ${s.last_name}`,
          }));

        return [...prevSelected, ...autoSelected];
      });
    }
  }, [students]);


  const handleBranchChange = (branch) => {
    setSelectedBranch(branch);
    setSelectedClasses([]);
    setSections([]);
    setSelectedSections([]);
    setStudents([]);
  };

  const handleClassChange = (clsArray) => {
    setSelectedClasses(clsArray);
    setStudents([]);
    setSections([]);
    setSelectedSections([]);

    if (selectedBranch && clsArray.length > 0) {
      const classNames = clsArray.map(c => c.label);
      fetchSections(selectedBranch.value, classNames);
    }
  };

  useEffect(() => {
    if (selectedBranch && selectedClasses.length > 0 && selectedSections.length > 0) {
      setStudents([]);
      selectedClasses.forEach(cls => {
        fetchStudents(selectedBranch.value, cls.label, true);
      });
    }
  }, [selectedSections]);

  const handleSaveSelection = () => {
    const newSelection = {
      branch: selectedBranch,
      classes: selectedClasses,
      students: selectedStudents,
    };

    setSelections((prev) => [...prev, newSelection]);

    setSelectedBranch(null);
    setSelectedClasses([]);
    setSelectedStudents([]);
  };

  const handleDeleteSelection = (index) => {
    setSelections((prev) => prev.filter((_, i) => i !== index));
  };

  async function fetchModules() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "classDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("class/classCurl", fd);
      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    } finally {
      setLoading(false);
    }
  }

  async function handlePublish() {
    if (!publishDate || !publishPaperId) {
      toast.error("Please select a date & time");
      return;
    }
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "publishResult";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("resultDate", publishDate);
      fd.append("paperId", publishPaperId);

      const response = await api.post("paper/paperCurl", fd);
      if (response.data.status) {
        toast.success("Result published successfully");
        setPublishModal(false);
        setPublishDate("");
        setPublishPaperId(null);
        fetchData();
      } else {
        toast.error(response.data.data || "Failed to publish");
      }
    } catch (error) {
      toast.error("Error publishing result");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchData(page = 1, term = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getPaperDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      if (activeTab === "published") {
        fd.append("published", 1);
      }
      if (activeTab === "evaluated") {
        fd.append("evaluated", 1);
      }
      if (activeTab === "notEvaluated") {
        fd.append("notEvaluated", 1);
      }
      if (examFilter) {
        fd.append("examType", examFilter);
      }
      if (term.trim() !== "") {
        fd.append("searchTerm", term.trim());
      }

      const response = await api.post("paper/paperCurl", fd);
      console.log("pper", response)
      if (response.data && Array.isArray(response.data.getPaperDetails)) {
        setFetchedData(response.data.getPaperDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching papers:", error);
      setFetchedData([]);
    } finally {
      setDataLoading(false);
    }
  }

  async function fetchExamType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getExamTypes");

      const response = await api.post("question/examType", fd);

      if (response?.data?.examTypes) {
        setExamTypes(response.data.examTypes);
      } else {
        setExamTypes([]);
      }

    } catch (error) {
      console.error("Error fetching exam types:", error);
      setExamTypes([]);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setButtonText(ID ? "Updating..." : "Adding...");

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updatePaper" : "addPaper";

    const fd = new FormData();
    fd.append("paperName", paperName);
    fd.append("template", selectedTemplate);
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("isPreviousYear", previousYear ? "yes" : "no");
    fd.append("token", token);
    fd.append("instantResult", "no");
    if (examInstructions) {
      fd.append("instruction", examInstructions);
    }

    if (ID) {
      fd.append("id", ID);
    }

    selectedModules.forEach((item, index) => {
      fd.append(`class[${index}]`, item.label);
    });

    selections.forEach((selection) => {
      selection.classes.forEach((cls) => {
        fd.append(`class[]`, cls.label);
      });
      selection.students.forEach((student) => {
        fd.append(`students[]`, student.value || "");
      });
    });

    fd.append("startDate", startDate);
    fd.append("endDate", endDate || "");
    fd.append("examType", examMode);
    fd.append("type", selectedExamType);
    fd.append("noOfAttempts", attempts);
    fd.append("noOfChance", tabSwitchLimit);
    fd.append("duration", duration || 60);

    fd.entries().forEach(([key, value]) => {
      console.log(key, value);
    });

    try {
      const response = await api.post("paper/paperCurl", fd);
      console.log("res", response)
      if (response.data.status === true) {
        const newId = response.data.insertId;

        toast.success(response.data.data);

        // 🔥 navigate immediately
        if (newId) {
          navigate(`/pick-question-import/${newId}`);
          return; // stop further execution
        }

        // fallback (if no id)
        fetchData();
        setShow(false);
        handleClose();
      } else {
        toast.error(response.data.data);
      }
      setID(null);
    } catch (error) {
      toast.error("Error submitting form");
      console.error(error);
    } finally {
      setLoading(false);
      setButtonText("Add Paper");
    }
  }

  async function handleDelete(id) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deletePaper";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("paper/paperCurl", fd);
      if (response.data && response.data.data) {
        toast.success("Paper deleted successfully");
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting paper:", error);
    }
  }

  const handleShowAdd = () => {
    setPaperName("");
    setButtonText("Add Paper");
    setID(null);
    setShow(true);
  };

  async function handleShowEdit(paper) {
    setButtonText("Update Paper");

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", paper.id);

    try {
      const response = await api.post("paper/paperCurl", fd);

      console.log("edit", response)
      if (response.data && response.data.getPaperDetails) {
        const paperDetails = response.data.getPaperDetails;

        setPaperName(paperDetails.paperName);
        setSelectedTemplate(paperDetails.templateId);
        setExamInstructions(paperDetails.instruction || "");

        const selectedClasses = paperDetails.class
          .split(",")
          .map((cls) => cls.trim())
          .filter((cls) => cls !== "")
          .map((cls) => ({
            label: cls,
            value: cls,
          }));

        setSelectedModules(selectedClasses);

        // ✅ For OFFLINE → auto save into selections
        if (paperDetails.examType === "offline") {
          const newSelection = {
            branch: selectedBranch, // already defaulted
            classes: selectedClasses,
            students: [], // offline doesn't need students
          };

          setSelections([newSelection]);
        }
        setStartDate(paperDetails.startDate);
        setEndDate(paperDetails.endDate);
        setExamMode(paperDetails.examType);
        setAttempts(paperDetails.noOfAttempts);
        setTabSwitchLimit(paperDetails.noOfChance);
        setDuration(paperDetails.duration);
        setSelectedExamType(paperDetails.type);
        setPreviousYear(paperDetails?.isPreviousYear === "yes");

        setID(paper.id);
        setShow(true);

        if (paperDetails.students && Array.isArray(response.data.students)) {
          const formatted = response.data.students.map(s => ({
            value: s.id,
            label: s.name
          }));
          setSelectedStudents(formatted);
        }
      }
    } catch (error) {
      toast.error("Failed to load paper details");
      console.error("Error fetching paper details:", error);
    }
  }

  const handleDeleteStudent = (studentId) => {
    setSelectedStudents((prev) => prev.filter(s => s.value !== studentId));
  };

  const handleClose = () => {
    setShow(false);
    setPaperName("");
    setID(null);
    setSelections([]);
    setSelectedBranch(null);
    setSelectedClasses([]);
    setSelectedStudents([]);
    setSelectedTemplate("");
    setStartDate("");
    setEndDate("");
    setExamMode("");
    setAttempts(1);
    setTabSwitchLimit(0);
    setDuration(60);
    setExamInstructions("");
    setSelectedExamType("");
    setPreviousYear(false);
    setCurrentStep(1); // Reset to step 1
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      const params = new URLSearchParams(location.search);
      params.set("page", page);

      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: false }
      );

      fetchData(page, searchTerm);
    }
  };


  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  async function handleConfirmEvaluate() {
    setEvaluating(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "updateAnswerInPaper");
      fd.append("paperId", evaluateId);

      const response = await api.post("examPaper/exam", fd);
      if (response.data?.status === "success") {
        toast.success(response.data?.message);
        fetchData();
      } else {
        toast.error(response.data?.message || "Failed to evaluate");
      }
      setConfirmEvaluate(false);
    } catch (error) {
      console.error(error);
      toast.error("Error evaluating");
    } finally {
      setEvaluating(false);
    }
  }

  const menuItemStyle = {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "13px",
    color: "#334155",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "transparent",
    border: "none",
    width: "100%",
    textAlign: "left",
    transition: "all 0.15s ease",
  };


  useEffect(() => {
    const closeMenu = () => setOpenMenuId(null);
    window.addEventListener("click", closeMenu);
    return () => window.removeEventListener("click", closeMenu);
  }, []);

  const handleVerifyAnswers = () => {
    if (!evaluateId) return;
    navigate(`/verify-answers/${evaluateId}`);
    setConfirmEvaluate(false);
  };

  useEffect(() => {
    const pageFromUrl = getPageFromUrl();
    fetchData(pageFromUrl, searchTerm);
  }, [activeTab, examFilter, location.search]);

  useEffect(() => {
    if (examMode === "offline") {
      setEndDate("");
    }
  }, [examMode]);

  const isLastRows = (index) => {
    return index >= fetchedData.length; // last 2 rows
  };




  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                  Paper Management
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  <Link to="/" style={{ color: "#64748b", textDecoration: "none" }}>Home</Link>
                  <span>/</span>
                  <span style={{ color: "#3E80F9", fontWeight: "500" }}>Paper Details</span>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search papers..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "320px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, searchTerm)}
                  />
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add New Paper
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Filter Section */}
          <div style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "14px",
            marginBottom: "10px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
          }}>
            {/* Status Tabs */}
            <div style={{ marginBottom: "10px" }}>

              <div style={{
                display: "flex",
                gap: "0",
                borderBottom: "2px solid #e5e7eb"
              }}>
                {[
                  { key: "", label: "📃 All Papers", color: "#3E80F9" },
                  { key: "published", label: "📢 Published", color: "#22c55e" },
                  { key: "evaluated", label: "✅ Evaluated", color: "#10b981" },
                  { key: "notEvaluated", label: "⏳ Not Evaluated", color: "#f59e0b" }
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      padding: "12px 24px",
                      background: "transparent",
                      border: "none",
                      borderBottom: activeTab === tab.key ? `3px solid ${tab.color}` : "3px solid transparent",
                      color: activeTab === tab.key ? tab.color : "#64748b",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Exam Mode Filter */}
            <div>

              <div style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap"
              }}>
                {[
                  { key: "", label: "All Modes", icon: "🌐", color: "#3E80F9" },
                  { key: "online", label: "Online Exam", icon: "🌐", color: "#22c55e" },
                  { key: "offline", label: "Offline Exam", icon: "🏫", color: "#6366f1" }
                ].map((mode) => (
                  <button
                    key={mode.key}
                    onClick={() => setExamFilter(mode.key)}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "10px",
                      border: "none",
                      background: examFilter === mode.key ? mode.color : "#f8fafc",
                      color: examFilter === mode.key ? "#fff" : "#64748b",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      boxShadow: examFilter === mode.key ? `0 2px 8px ${mode.color}40` : "none"
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>{mode.icon}</span>
                    {mode.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Papers Table */}
          {/* Papers Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "600px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "48px",
                        minWidth: "48px",
                        maxWidth: "48px",
                        padding: "14px 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      #
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Paper Details
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Questions
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Actions
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      More
                    </th>
                  </tr>
                </thead>


                {dataLoading ? (
                  <TableLoader rows={6} columns={5} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              📄
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No papers found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm || activeTab || examFilter
                                ? "Try adjusting your filters"
                                : "Create your first paper"}
                            </div>
                            {!searchTerm && !activeTab && !examFilter && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleShowAdd}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Create First Paper
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((paper, index) => (
                        <tr key={paper.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s"
                        }}>
                          <td
                            style={{
                              width: "48px",
                              minWidth: "48px",
                              maxWidth: "48px",
                              padding: "6px",
                              fontSize: "12px",
                              color: "#64748b",
                              fontWeight: "500",
                              textAlign: "center",
                              whiteSpace: "nowrap"
                            }}
                          >

                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#475569",
                                margin: "0 auto"
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>

                          </td>
                          <td style={{ padding: "12px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                              <div style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#1e293b",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap"
                              }}>
                                <span style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "250px"
                                }}>
                                  {paper.paperName}
                                </span>
                                <div style={{ display: "flex", gap: "4px" }}>

                                  {paper.typeName && (
                                    <span style={{
                                      background: "#eef2ff",
                                      color: "#3730a3",
                                      fontSize: "10px",
                                      fontWeight: "700",
                                      padding: "2px 8px",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "3px",
                                      whiteSpace: "nowrap"
                                    }}>
                                      🎯 {paper.typeName}
                                    </span>
                                  )}

                                  {/* ✅ NEW: Previous Year Badge */}
                                  {paper.isPreviousYear === "yes" && (
                                    <span style={{
                                      background: "#fff7ed",
                                      color: "#c2410c",
                                      fontSize: "10px",
                                      fontWeight: "700",
                                      padding: "2px 8px",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "3px",
                                      whiteSpace: "nowrap"
                                    }}>
                                      📚 PREVIOUS YEAR
                                    </span>
                                  )}
                                  {paper.examType?.toLowerCase() === "online" && (
                                    <span style={{
                                      background: "#dcfce7",
                                      color: "#166534",
                                      fontSize: "10px",
                                      fontWeight: "600",
                                      padding: "2px 8px",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "2px",
                                      whiteSpace: "nowrap"
                                    }}>
                                      <Globe size={10} /> ONLINE
                                    </span>
                                  )}
                                  {paper.examType?.toLowerCase() === "offline" && (
                                    <span style={{
                                      background: "#f0f9ff",
                                      color: "#0369a1",
                                      fontSize: "10px",
                                      fontWeight: "600",
                                      padding: "2px 8px",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "2px",
                                      whiteSpace: "nowrap"
                                    }}>
                                      <Building size={10} /> OFFLINE
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div style={{
                                fontSize: "12px",
                                color: "#64748b",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap"
                              }}>
                                <span>⏱️ {paper.duration} min</span>
                                <span>📅 {new Date(paper.startDate).toLocaleDateString('en-GB')}</span>
                                <span>👤 {paper.attemptedStudents}</span>
                                {paper.extraAttemptedStudents > 0 ?
                                  <span>➕ {paper.extraAttemptedStudents}</span>
                                  :
                                  ""}

                              </div>
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#334155",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <span style={{ fontWeight: "600" }}>
                              {paper.selectedQuestions}
                            </span>
                            <span style={{ color: "#94a3b8", margin: "0 4px" }}>
                              /
                            </span>
                            <span>
                              {paper.noOfQuestions}
                            </span>
                          </td>

                          <td style={{ padding: "12px", textAlign: "center" }}>
                            <div style={{
                              display: "flex",
                              gap: "6px",
                              justifyContent: "center",
                              flexWrap: "wrap"
                            }}>
                              {userPermissions1.is_add === "1" && (
                                <button
                                  onClick={() => navigate(`/pick-question-import/${paper.id}`)}
                                  title="Add Questions"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#f0fdf4",
                                    color: "#16a34a",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s",
                                    flexShrink: 0
                                  }}
                                >
                                  <span style={{ fontSize: "16px", fontWeight: "600" }}>+</span>
                                </button>
                              )}

                              {userPermissions.is_edit === "1" && (
                                <button
                                  onClick={() => handleShowEdit(paper)}
                                  title="Edit Paper"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#eff6ff",
                                    color: "#3b82f6",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s",
                                    flexShrink: 0
                                  }}
                                >
                                  <PencilSimpleLine size={14} />
                                </button>
                              )}

                              {userPermissions.is_delete === "1" && (
                                <button
                                  onClick={() => handleDelete(paper.id)}
                                  title="Delete Paper"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#fef2f2",
                                    color: "#dc2626",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s",
                                    flexShrink: 0
                                  }}
                                >
                                  <Trash size={14} />
                                </button>
                              )}

                              <button
                                onClick={() =>
                                  navigate(`/paper-overview/${paper.id}`, {
                                    state: { templateId: paper.templateId }
                                  })
                                }
                                title="Overview"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "8px",
                                  border: "none",
                                  background: "#f0f9ff",
                                  color: "#0ea5e9",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "all 0.2s",
                                  flexShrink: 0
                                }}
                              >
                                <Eye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={{ padding: "12px", textAlign: "center", position: "relative" }}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenuId(openMenuId === paper.id ? null : paper.id);
                              }}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "8px",
                                border: "none",
                                background: "#f8fafc",
                                color: "#64748b",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s",
                                margin: "0 auto"
                              }}
                            >
                              <DotsThreeVertical size={16} />
                            </button>

                            {openMenuId === paper.id && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "6px",
                                  top: isLastRows(index) ? "auto" : "42px",
                                  bottom: isLastRows(index) ? "42px" : "auto",
                                  background: "#ffffff",
                                  borderRadius: "12px",
                                  boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
                                  border: "1px solid #e5e7eb",
                                  minWidth: "190px",
                                  zIndex: 9999,
                                  overflow: "hidden",
                                  animation: "fadeIn 0.15s ease-out"
                                }}
                              >

                                <div
                                  style={{
                                    padding: "10px 14px",
                                    background: "#f8fafc",
                                    borderBottom: "1px solid #e5e7eb",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    color: "#64748b",
                                    letterSpacing: "0.6px"
                                  }}
                                >
                                  ACTIONS
                                </div>
                                {userPermissions.is_delete === "1" && (

                                  <button
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                    style={menuItemStyle}

                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/view-questions/${paper.id}?paperName=${encodeURIComponent(
                                        paper.paperName
                                      )}&startDate=${paper.startDate}&duration=${paper.duration}`);
                                      setOpenMenuId(null);
                                    }}
                                  >
                                    <DownloadSimple size={14} />
                                    Download
                                  </button>

                                )}


                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/attempted-list/${paper.id}`);
                                    setOpenMenuId(null);
                                  }}
                                  style={{
                                    ...menuItemStyle,
                                    fontSize: "12px",
                                    padding: "8px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                  }}
                                >
                                  <Users size={12} /> Attempted
                                </button>

                                <button
                                  onClick={() => {
                                    navigate(`/paper-analysis/${paper.id}`);
                                    setOpenMenuId(null);
                                  }}
                                  style={{
                                    ...menuItemStyle,
                                    fontSize: "12px",
                                    padding: "8px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                  }}
                                >
                                  <ChartBar size={12} /> Overview
                                </button>

                                {paper.examType?.toLowerCase() !== "online" && (
                                  <button
                                    onClick={() => {
                                      navigate(`/import-omr/${paper.id}`);
                                      setOpenMenuId(null);
                                    }}
                                    style={{
                                      ...menuItemStyle,
                                      fontSize: "12px",
                                      padding: "8px 12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px"
                                    }}
                                  >
                                    <Upload size={12} /> Import Excel
                                  </button>
                                )}

                                {!paper.resultDate && (
                                  <button
                                    onClick={() => {
                                      setPublishPaperId(paper.id);
                                      setPublishModal(true);
                                      setOpenMenuId(null);
                                    }}
                                    style={{
                                      ...menuItemStyle,
                                      fontSize: "12px",
                                      padding: "8px 12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      color: "#f59e0b"
                                    }}
                                  >
                                    <Clock size={12} /> Publish
                                  </button>
                                )}

                                {paper.evaluated === 0 && (
                                  <button
                                    onClick={() => {
                                      setEvaluateId(paper.id);
                                      setConfirmEvaluate(true);
                                      setOpenMenuId(null);
                                    }}
                                    style={{
                                      ...menuItemStyle,
                                      fontSize: "12px",
                                      padding: "8px 12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      color: "#10b981"
                                    }}
                                  >
                                    <CheckCircle size={12} /> Evaluate
                                  </button>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Compact Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />

      {/* Confirm Evaluate Modal */}
      <Modal show={confirmEvaluate} onHide={() => setConfirmEvaluate(false)} centered>
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "24px",
          background: "#f8fafc"
        }}>
          <Modal.Title style={{ fontSize: "18px", fontWeight: "700", color: "fff" }}>
            <CheckCircle size={24} style={{ marginRight: "12px", color: "#10b981" }} />
            Confirm Evaluation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <div style={{
            background: "#f0f9ff",
            padding: "16px",
            borderRadius: "12px",
            marginBottom: "20px"
          }}>
            <p style={{
              marginBottom: "12px",
              color: "#475569",
              fontSize: "15px",
              lineHeight: "1.6"
            }}>
              This will evaluate all submitted answers and calculate scores for students.
            </p>
            <p style={{
              marginBottom: "0",
              color: "#64748b",
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              ⚠️ This action cannot be undone.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{
          padding: "24px",
          borderTop: "1px solid #e5e7eb",
          background: "#f8fafc"
        }}>
          <Button
            variant="secondary"
            onClick={() => setConfirmEvaluate(false)}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
          >
            Cancel
          </Button>
          <div style={{ display: "flex", gap: "12px" }}>
            <Button
              variant="secondary"
              onClick={handleVerifyAnswers}
              style={{
                background: "#3E80F9",
                color: "#fff",
                border: "none",
                padding: "10px 24px",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "600",
                transition: "all 0.2s"
              }}
            >
              Verify Answers First
            </Button>
            <Button
              variant="primary"
              disabled={evaluating}
              onClick={handleConfirmEvaluate}
              style={{
                background: "#10b981",
                color: "#fff",
                border: "none",
                padding: "10px 24px",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "600",
                transition: "all 0.2s",
                opacity: evaluating ? 0.7 : 1,
                minWidth: "140px"
              }}
            >
              {evaluating ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    style={{ marginRight: "8px" }}
                  />
                  Evaluating...
                </>
              ) : (
                "Confirm Evaluation"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Add/Edit Paper Modal */}
      {/* Add/Edit Paper Modal with Stepper - MODERN DESIGN ONLY, FUNCTIONALITY UNCHANGED */}
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered size="lg">
        <Modal.Header closeButton style={{
          borderBottom: "none",
          padding: "28px 32px 20px 32px",
          background: "#fff"
        }}>
          <div>
            <Modal.Title style={{
              fontSize: "24px",
              fontWeight: "600",
              marginBottom: "4px",
              color: "#111827",
              letterSpacing: "-0.01em"
            }}>
              {ID ? "Edit Paper" : "Create New Paper"}
            </Modal.Title>
            <div style={{
              fontSize: "14px",
              color: "#6B7280"
            }}>
              {ID ? "Update paper details and settings" : "Configure your paper in 4 easy steps"}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={{
          padding: "0",
          maxHeight: "70vh",
          overflowY: "auto",
          background: "#fff"
        }}>
          {/* Modern Stepper Header - Same steps, just styled better */}
          <div style={{
            display: "flex",
            padding: "0 32px",
            borderBottom: "1px solid #F3F4F6",
            background: "#fff",
            gap: "8px"
          }}>
            <div
              onClick={() => setCurrentStep(1)}
              style={{
                flex: 1,
                padding: "20px 0 16px 0",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                borderBottom: currentStep === 1 ? "2px solid #3B82F6" : "2px solid transparent",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                background: currentStep === 1 || currentStep > 1 ? "#3B82F6" : "#F3F4F6",
                color: currentStep === 1 || currentStep > 1 ? "#fff" : "#9CA3AF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "600",
                fontSize: "14px"
              }}>
                {currentStep > 1 ? <Check size={16} /> : 1}
              </div>
              <div>
                <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", letterSpacing: "0.5px" }}>STEP 1</div>
                <div style={{ fontSize: "13px", fontWeight: "500", color: currentStep === 1 ? "#111827" : "#6B7280" }}>
                  Exam Details
                </div>
              </div>
            </div>

            <div
              onClick={() => currentStep > 1 && setCurrentStep(2)}
              style={{
                flex: 1,
                padding: "20px 0 16px 0",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                borderBottom: currentStep === 2 ? "2px solid #3B82F6" : "2px solid transparent",
                cursor: currentStep > 1 ? "pointer" : "not-allowed",
                transition: "all 0.2s ease",
                opacity: currentStep > 1 ? 1 : 0.5
              }}
            >
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                background: currentStep === 2 || currentStep > 2 ? "#3B82F6" : "#F3F4F6",
                color: currentStep === 2 || currentStep > 2 ? "#fff" : "#9CA3AF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "600",
                fontSize: "14px"
              }}>
                {currentStep > 2 ? <Check size={16} /> : 2}
              </div>
              <div>
                <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", letterSpacing: "0.5px" }}>STEP 2</div>
                <div style={{ fontSize: "13px", fontWeight: "500", color: currentStep === 2 ? "#111827" : "#6B7280" }}>
                  Participants
                </div>
              </div>
            </div>

            <div
              onClick={() => currentStep > 2 && setCurrentStep(3)}
              style={{
                flex: 1,
                padding: "20px 0 16px 0",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                borderBottom: currentStep === 3 ? "2px solid #3B82F6" : "2px solid transparent",
                cursor: currentStep > 2 ? "pointer" : "not-allowed",
                transition: "all 0.2s ease",
                opacity: currentStep > 2 ? 1 : 0.5
              }}
            >
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                background: currentStep === 3 || currentStep > 3 ? "#3B82F6" : "#F3F4F6",
                color: currentStep === 3 || currentStep > 3 ? "#fff" : "#9CA3AF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "600",
                fontSize: "14px"
              }}>
                {currentStep > 3 ? <Check size={16} /> : 3}
              </div>
              <div>
                <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", letterSpacing: "0.5px" }}>STEP 3</div>
                <div style={{ fontSize: "13px", fontWeight: "500", color: currentStep === 3 ? "#111827" : "#6B7280" }}>
                  Schedule & Settings
                </div>
              </div>
            </div>

            <div
              onClick={() => currentStep > 3 && setCurrentStep(4)}
              style={{
                flex: 1,
                padding: "20px 0 16px 0",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                borderBottom: currentStep === 4 ? "2px solid #3B82F6" : "2px solid transparent",
                cursor: currentStep > 3 ? "pointer" : "not-allowed",
                transition: "all 0.2s ease",
                opacity: currentStep > 3 ? 1 : 0.5
              }}
            >
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                background: currentStep === 4 ? "#3B82F6" : "#F3F4F6",
                color: currentStep === 4 ? "#fff" : "#9CA3AF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "600",
                fontSize: "14px"
              }}>
                4
              </div>
              <div>
                <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", letterSpacing: "0.5px" }}>STEP 4</div>
                <div style={{ fontSize: "13px", fontWeight: "500", color: currentStep === 4 ? "#111827" : "#6B7280" }}>
                  Instructions
                </div>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div style={{ padding: "32px" }}>
            <form onSubmit={handleSubmit} id="module-form">

              {/* STEP 1: Exam Details - EXACT SAME FIELDS, JUST STYLED */}
              {currentStep === 1 && (
                <div>
                  <div style={{ marginBottom: "28px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                      Paper Name <span style={{ color: "#EF4444" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter paper name (e.g., 'Physics Midterm 2024')"
                      value={paperName}
                      onChange={(e) => setPaperName(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "1px solid #E5E7EB",
                        borderRadius: "10px",
                        fontSize: "14px",
                        transition: "all 0.2s",
                        background: "#fff"
                      }}
                    />
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "28px" }}>
                    <div>
                      <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                        Exam Mode <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <div style={{ display: "flex", gap: "12px" }}>
                        <label style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px 16px",
                          borderRadius: "10px",
                          border: examMode === "online" ? "1px solid #10B981" : "1px solid #E5E7EB",
                          background: examMode === "online" ? "#ECFDF5" : "#fff",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          fontWeight: "500"
                        }}>
                          <input
                            type="radio"
                            value="online"
                            checked={examMode === "online"}
                            onChange={(e) => setExamMode(e.target.value)}
                            style={{ cursor: "pointer" }}
                          />
                          🌐 Online
                        </label>
                        <label style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px 16px",
                          borderRadius: "10px",
                          border: examMode === "offline" ? "1px solid #6366F1" : "1px solid #E5E7EB",
                          background: examMode === "offline" ? "#EEF2FF" : "#fff",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          fontWeight: "500"
                        }}>
                          <input
                            type="radio"
                            value="offline"
                            checked={examMode === "offline"}
                            onChange={(e) => setExamMode(e.target.value)}
                            style={{ cursor: "pointer" }}
                          />
                          🏫 Offline
                        </label>
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                        Select Exam <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedExamType}
                        onChange={(e) => setSelectedExamType(e.target.value)}
                        required
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          fontSize: "14px",
                          background: "#fff"
                        }}
                      >
                        <option value="">Select Exam</option>
                        {examTypes.map((exam) => (
                          <option key={exam.id} value={exam.id}>
                            {exam.examType}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* STEP 2: Participants Selection - EXACT SAME LOGIC, JUST STYLED */}
              {currentStep === 2 && (
                <div>



                  {/* Class */}
                  <div style={{ marginBottom: "24px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                      Class <span style={{ color: "#EF4444" }}>*</span>
                    </label>
                    <Select
                      isMulti
                      options={modules.map((m) => ({
                        label: m.moduleName,
                        value: m.moduleName,
                      }))}
                      value={selectedClasses}
                      onChange={handleClassChange}
                      placeholder="Select Classes"
                      className="modern-select"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          fontSize: "14px",
                          minHeight: "46px"
                        })
                      }}
                    />
                  </div>

                  {/* Conditional Fields based on Exam Mode - KEEP ORIGINAL LOGIC */}
                  {examMode === "online" ? (
                    <>
                      <div style={{ marginBottom: "24px" }}>
                        <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                          Sections
                        </label>
                        <Select
                          isMulti
                          options={sections.map((s) => ({
                            label: s.name,
                            value: s.id,
                          }))}
                          value={selectedSections}
                          onChange={(vals) => {
                            setSelectedSections(vals || []);
                            if (!vals || vals.length === 0) {
                              setStudents([]);
                            }
                          }}
                          placeholder="Select Sections"
                          isDisabled={!sections.length}
                          className="modern-select"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              minHeight: "46px"
                            })
                          }}
                        />
                      </div>

                      <div style={{ marginBottom: "24px" }}>
                        <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                          Students
                        </label>
                        <Select
                          isMulti
                          options={studentOptions}
                          value={selectedStudents}
                          onChange={setSelectedStudents}
                          placeholder="Select Students by Roll No"
                          className="modern-select"
                          classNamePrefix="react-select"
                          closeMenuOnSelect={false}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              minHeight: "46px"
                            })
                          }}
                        />
                      </div>

                      <div style={{ marginTop: "20px", textAlign: "right" }}>
                        <button
                          type="button"
                          onClick={handleSaveSelection}
                          style={{
                            background: "#10B981",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer"
                          }}
                        >
                          💾 Save Selection
                        </button>
                      </div>
                    </>
                  ) : examMode === "offline" ? (
                    <>
                      <div style={{ marginTop: "16px", marginBottom: "20px" }}>
                        <button
                          type="button"
                          onClick={handleSaveSelection}
                          style={{
                            background: "#10B981",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                          }}
                        >
                          💾 Save Selection
                        </button>
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "40px", background: "#F9FAFB", borderRadius: "10px" }}>
                      <p style={{ color: "#6B7280" }}>Please select Exam Mode in Step 1 first</p>
                    </div>
                  )}

                  {/* Saved Selections - KEEP ORIGINAL */}
                  {selections.length > 0 && (
                    <div style={{ marginTop: "24px" }}>
                      <label style={{ fontSize: "13px", fontWeight: "600", marginBottom: "12px", display: "block", color: "#111827" }}>
                        Saved Selections
                      </label>
                      <div style={{
                        background: "#F9FAFB",
                        borderRadius: "10px",
                        border: "1px solid #E5E7EB",
                        padding: "12px",
                        maxHeight: "150px",
                        overflowY: "auto"
                      }}>
                        {selections.map((sel, idx) => (
                          <div key={idx} style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                            background: "#fff",
                            borderRadius: "8px",
                            marginBottom: "8px",
                            border: "1px solid #E5E7EB"
                          }}>
                            <div style={{ fontSize: "12px", color: "#475569" }}>
                              <div><strong>Classes:</strong> {sel.classes.map(c => c.label).join(", ")}</div>
                              {examMode !== "offline" && (
                                <div>Students: {selections.reduce((acc, s) => acc + s.students.length, 0)} selected</div>
                              )}
                            </div>
                            <button
                              type="button"
                              onClick={() => handleDeleteSelection(idx)}
                              style={{
                                background: "#FEF2F2",
                                color: "#EF4444",
                                border: "none",
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* STEP 3: Schedule & Settings - TEMPLATE SELECTION IS HERE (ORIGINAL POSITION) */}
              {currentStep === 3 && (
                <div>
                  <div style={{ marginBottom: "28px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                      Exam Schedule
                    </label>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: examMode === "offline" ? "1fr" : "1fr 1fr",
                      gap: "16px"
                    }}>
                      <div>
                        <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "6px", display: "block", color: "#6B7280" }}>
                          Start Date & Time
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "12px 16px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "10px",
                            fontSize: "14px",
                            background: "#fff"
                          }}
                        />
                      </div>
                      {examMode !== "offline" && (
                        <div>
                          <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "6px", display: "block", color: "#6B7280" }}>
                            End Date & Time
                          </label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              background: "#fff"
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Template Selection - ORIGINAL POSITION (Step 3) */}
                  <div style={{ marginBottom: "24px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px", display: "block", color: "#374151" }}>
                      Select Template <span style={{ color: "#EF4444" }}>*</span>
                    </label>
                    <select
                      className="form-control"
                      value={selectedTemplate}
                      onChange={(e) => {
                        if (e.target.value === "add_new") {
                          setShowTemplateModal(true);
                        } else {
                          setSelectedTemplate(e.target.value);
                        }
                      }}
                      required
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "1px solid #E5E7EB",
                        borderRadius: "10px",
                        fontSize: "14px",
                        background: "#fff"
                      }}
                    >
                      <option value="">Select a template</option>
                      {templates.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.name}
                        </option>
                      ))}
                      <option value="add_new">➕ Add New Template</option>
                    </select>
                  </div>

                  {/* Previous Year Checkbox */}
                  <div style={{ marginBottom: "24px" }}>
                    <label style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#374151",
                      cursor: "pointer"
                    }}>
                      <input
                        type="checkbox"
                        checked={previousYear}
                        onChange={(e) => setPreviousYear(e.target.checked)}
                        style={{ width: "18px", height: "18px", cursor: "pointer" }}
                      />
                      📚 Previous Year Question Paper?
                    </label>
                  </div>

                  {/* Online-specific settings */}
                  {examMode === "online" && (
                    <div>
                      <label style={{ fontSize: "13px", fontWeight: "600", marginBottom: "12px", display: "block", color: "#111827" }}>
                        Online Exam Settings
                      </label>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
                        <div>
                          <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "6px", display: "block", color: "#6B7280" }}>
                            Number of Attempts
                          </label>
                          <input
                            type="number"
                            min={1}
                            className="form-control"
                            value={attempts}
                            onChange={(e) => setAttempts(parseInt(e.target.value) || 1)}
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              background: "#fff"
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "6px", display: "block", color: "#6B7280" }}>
                            Tab Switch Limit
                          </label>
                          <input
                            type="number"
                            min={0}
                            className="form-control"
                            value={tabSwitchLimit}
                            onChange={(e) => setTabSwitchLimit(parseInt(e.target.value) || 0)}
                            placeholder="0 = Unlimited"
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              background: "#fff"
                            }}
                          />
                          <small style={{ color: "#9CA3AF", fontSize: "11px" }}>
                            Number of times student can switch tabs
                          </small>
                        </div>
                        <div>
                          <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "6px", display: "block", color: "#6B7280" }}>
                            Duration (minutes)
                          </label>
                          <input
                            type="number"
                            min={1}
                            className="form-control"
                            value={duration}
                            onChange={(e) => setDuration(parseInt(e.target.value) || 60)}
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              border: "1px solid #E5E7EB",
                              borderRadius: "10px",
                              fontSize: "14px",
                              background: "#fff"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* STEP 4: Instructions - EXACT SAME, JUST STYLED */}
              {currentStep === 4 && (
                <div>
                  <label style={{ fontSize: "13px", fontWeight: "600", marginBottom: "12px", display: "block", color: "#111827" }}>
                    Exam Instructions
                  </label>
                  <div style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: "10px",
                    overflow: "hidden"
                  }}>
                    <ReactQuill
                      theme="snow"
                      value={examInstructions}
                      onChange={setExamInstructions}
                      placeholder="Enter exam instructions (rules, guidelines, important notes...)"
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["link"],
                          ["clean"],
                        ],
                      }}
                      style={{ height: "180px", marginBottom: "50px" }}
                    />
                  </div>

                  {/* Review Summary */}
                  <div style={{
                    marginTop: "28px",
                    padding: "16px",
                    background: "#F0F9FF",
                    borderRadius: "10px",
                    border: "1px solid #BAE6FD"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                      <CheckCircle size={18} color="#0284C7" />
                      <span style={{ fontWeight: "600", color: "#0C4A6E" }}>Review Summary</span>
                    </div>
                    <div style={{ fontSize: "13px", color: "#075985", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                      <div>📝 Paper: <strong>{paperName || "Not set"}</strong></div>
                      <div>🎨 Template: <strong>{selectedTemplate ? templates.find(t => t.id == selectedTemplate)?.name || "Selected" : "Not set"}</strong></div>
                      <div>🌐 Mode: <strong>{examMode || "Not set"}</strong></div>
                      <div>📚 Exam: <strong>{selectedExamType ? examTypes.find(e => e.id == selectedExamType)?.examType : "Not set"}</strong></div>
                      {examMode === "online" && (
                        <>
                          <div>⏱️ Duration: <strong>{duration} min</strong></div>
                          <div>🔄 Attempts: <strong>{attempts}</strong></div>
                          <div>🚫 Tab Switches: <strong>{tabSwitchLimit === 0 ? "Unlimited" : tabSwitchLimit}</strong></div>
                        </>
                      )}
                      <div>📅 Schedule: <strong>{startDate ? new Date(startDate).toLocaleDateString() : "Not set"}</strong></div>
                      {previousYear && <div>📚 Previous Year: <strong>Yes</strong></div>}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </Modal.Body>

        <Modal.Footer style={{
          borderTop: "1px solid #F3F4F6",
          padding: "20px 32px",
          background: "#fff",
          justifyContent: "space-between"
        }}>
          <div>
            {currentStep > 1 && (
              <button
                type="button"
                onClick={() => setCurrentStep(currentStep - 1)}
                style={{
                  background: "#F9FAFB",
                  color: "#374151",
                  border: "1px solid #E5E7EB",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                <ArrowLeft size={16} /> Back
              </button>
            )}
          </div>

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                background: "#fff",
                color: "#6B7280",
                border: "1px solid #E5E7EB",
                padding: "10px 20px",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer"
              }}
            >
              Cancel
            </button>

            {currentStep < 4 && (
              <button
                type="button"
                onClick={() => {
                  if (currentStep === 1) {
                    if (!paperName) {
                      toast.error("Please enter paper name");
                      return;
                    }
                    if (!examMode) {
                      toast.error("Please select exam mode");
                      return;
                    }
                    if (!selectedExamType) {
                      toast.error("Please select exam type");
                      return;
                    }
                  }
                  if (currentStep === 2) {
                    if (examMode === "offline" && selections.length === 0) {
                      toast.error("Please save at least one selection for offline exam");
                      return;
                    }
                  }
                  if (currentStep === 3) {
                    if (!startDate) {
                      toast.error("Please select start date & time");
                      return;
                    }
                    if (examMode !== "offline" && !endDate) {
                      toast.error("Please select end date & time");
                      return;
                    }
                    if (!selectedTemplate) {
                      toast.error("Please select a template");
                      return;
                    }
                    if (examMode === "online" && (!attempts || attempts < 1)) {
                      toast.error("Please enter valid number of attempts");
                      return;
                    }
                    if (examMode === "online" && (!duration || duration < 1)) {
                      toast.error("Please enter valid duration");
                      return;
                    }
                  }
                  setCurrentStep(currentStep + 1);
                }}
                style={{
                  background: "#3B82F6",
                  color: "#fff",
                  border: "none",
                  padding: "10px 28px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                Next <ArrowRight size={16} />
              </button>
            )}

            {currentStep === 4 && (
              <button
                type="submit"
                form="module-form"
                disabled={loading}
                style={{
                  background: "#10B981",
                  color: "#fff",
                  border: "none",
                  padding: "10px 28px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  opacity: loading ? 0.7 : 1,
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" />
                    {buttonText}
                  </>
                ) : (
                  <>
                    <Check size={16} />
                    {buttonText}
                  </>
                )}
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
      {/* Publish Modal */}
      <Modal show={publishModal} onHide={() => setPublishModal(false)} backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "24px",
          background: "#f8fafc"
        }}>
          <Modal.Title style={{ fontSize: "18px", fontWeight: "700", color: "#fff" }}>
            <Clock size={24} style={{ marginRight: "12px", color: "#f59e0b" }} />
            Publish Results
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <div style={{ marginBottom: "20px" }}>
            <label style={{
              display: "block",
              marginBottom: "10px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#374151"
            }}>
              Select Result Date & Time <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="datetime-local"
              className="form-control"
              value={publishDate}
              onChange={(e) => setPublishDate(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "2px solid #e2e8f0",
                borderRadius: "10px",
                fontSize: "14px",
                background: "#fff"
              }}
            />
            <small style={{ color: "#6b7280", fontSize: "13px", marginTop: "8px", display: "block" }}>
              Results will be visible to students from this date and time.
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer style={{
          padding: "24px",
          borderTop: "1px solid #e5e7eb",
          background: "#f8fafc"
        }}>
          <button
            type="button"
            onClick={() => setPublishModal(false)}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handlePublish}
            disabled={loading}
            style={{
              background: "#f59e0b",
              color: "#fff",
              border: "none",
              padding: "10px 32px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s",
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? "Publishing..." : "Publish Results"}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Template</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <Template
            onTemplateCreated={() => {
              setShowTemplateModal(false);
              fetchTemplates(); // refresh template list
            }}
          />
        </Modal.Body>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          .react-select__control {
            border-color: #e2e8f0 !important;
            min-height: 46px !important;
            border-radius: 10px !important;
            transition: all 0.2s !important;
          }
          
          .react-select__control:hover {
            border-color: #94a3b8 !important;
          }
          
          .react-select__control--is-focused {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
          
          .react-select__menu {
            z-index: 9999 !important;
            border-radius: 10px !important;
            box-shadow: 0 10px 40px rgba(0,0,0,0.1) !important;
          }
          
          .ql-toolbar {
            border-radius: 10px 10px 0 0 !important;
            border-color: #e2e8f0 !important;
          }
          
          .ql-container {
            border-radius: 0 0 10px 10px !important;
            border-color: #e2e8f0 !important;
            font-size: 14px;
            font-family: 'Inter', sans-serif;
          }
          
          .ql-editor {
            min-height: 120px;
            font-family: 'Inter', sans-serif;
          }
          
          input:hover, select:hover {
            border-color: #94a3b8 !important;
          }
          
          input:focus, select:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default PaperDetails;